export const getGlobalFontSize = () => {
  if (typeof window === 'undefined') return 16
  const fontSize = window.getComputedStyle(document.body).getPropertyValue('font-size')
  return fontSize ? parseFloat(fontSize.slice(0, -2) /* remove `px` from end */) : 16
}
